import { ButtonBase, Grid } from '@mui/material'
import React, { Fragment, useState } from 'react'
import PowerExtensionsLocationSelector from './PowerExtensionsLocationSelector'

const oddRow = {
  backgroundColor: '#f5fbff',
  color: 'black',
  height: '60px',
  padding: '22px',
  text: '24pt',
  width: '100%',
}

const evenRow = {
  backgroundColor: '#f2f2f2',
  color: 'black',
  height: '60px',
  padding: '22px',
  text: '24pt',
  width: '100%',
}

const button = {
  height: '60px',
  text: '24pt',
  textAlign: 'center',
  width: '100%',
}

const PowerExtensionsClientTable = ({
  client,
  clientsService,
  portals,
  powerExtensionService,
}) => {
  let showLocations = new Map()
  Object.keys(portals).forEach(portal =>
    showLocations.set(portal, useState(false)),
  )

  const handleLocationToggle = (showLocations, portal) => {
    showLocations.get(portal)[1](!showLocations.get(portal)[0])
  }

  return Object.keys(portals).map((portal, i) => {
    const thisStyle = i % 2 === 1 ? oddRow : evenRow
    return (
      <Fragment key={`${client}-${portal}-${i}-master-row`}>
        <Grid item xs={12}>
          <ButtonBase
            data-testid={`${client}-${portal}-row-button`}
            onClick={() => handleLocationToggle(showLocations, portal)}
            style={button}
          >
            <Grid container>
              <Grid item style={thisStyle} xs={4}>
                {portal}
              </Grid>
              <Grid item style={thisStyle} xs={4}>
                {portals[portal].portal_desc}
              </Grid>
              <Grid item style={thisStyle} xs={4}>
                {portals[portal].loc_count}
              </Grid>
            </Grid>
          </ButtonBase>
        </Grid>
        {showLocations.get(portal)[0] && (
          <PowerExtensionsLocationSelector
            client={client}
            clientsService={clientsService}
            id={`${client}-${portal}-${i}`}
            portal={portal}
            powerExtensionService={powerExtensionService}
          />
        )}
      </Fragment>
    )
  })
}

export default PowerExtensionsClientTable
